/* eslint-disable prettier/prettier */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import DynamicComponent from '../Components/DynamicComponent';
import 'react-tooltip/dist/react-tooltip.css';

//PandoNexis: BEGIN IMPORT
import MiniCartExtendedContainer from '../_Addons/PNMiniCartExtended/Components/MiniCartExtendedContainer';
//PandoNexis: END IMPORT

import './pn.events.js';
import './pn.functions.js';

const renderReact = (element, container, callback) => {
    window.__pn.registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
};

window.__pn = {
    ...window.__pn,
    initNewBuyButton: (button) => {
        initNewBuyButton(button);
    },
    cache: {}, // for storing cache data for current request
};

export const bootstrapPNComponents = () => {

    // Generic loader
    const loaderId = 'genericLoader';
    let loaderEl = document.getElementById(loaderId);
    if (!loaderEl) {
        loaderEl = document.createElement('div');
        loaderEl.id = loaderId;
        document.querySelector('body').append(loaderEl);
    }
    if (loaderEl) {
        const GenericLoader = DynamicComponent({
            loader: () => import('../_PandoNexis/Components/GenericLoader'),
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <GenericLoader />
            </Provider>,
            loaderEl
        );
    }

    // OrganizationSelector
    const organizationSelectors = document.querySelectorAll(".pn-organization-selector");
    if (organizationSelectors) {
        const OrganizationSelector = DynamicComponent({
            loader: () => import('../_Addons/PNOrganizationSelector/Components/OrganizationSelectorContainer'),
        });
        Array.from(organizationSelectors).forEach(
            (organizationSelector) => {
                renderReact(
                    <Provider store={window.__pn.store}>
                        <OrganizationSelector />
                    </Provider>,
                    organizationSelector
                );
            });
    }
    // END OrganizationSelector
    // Logged on info
    const loggedOnInfoLabels = document.querySelectorAll('.pn-info-label');
    if (loggedOnInfoLabels) {
        const LoggedOnInfoLabel = DynamicComponent({
            loader: () => import('../_Addons/PNLoggedOnInfoLabel/Components/LoggedOnInfoLabelContainer'),
        });

        loggedOnInfoLabels.forEach((elem, index) => {
            const { heading } = elem.dataset;
            renderReact(
                <Provider store={window.__pn.store}>
                    <LoggedOnInfoLabel getData={index === 0} heading={heading || ''} />
                </Provider>,
                elem
            );
        });
    }
    const initNewBuyButton = (button, buyButtonComponent) => {
        const BuyButton = buyButtonComponent ? buyButtonComponent : DynamicComponent({
            loader: () => import('../_PandoNexis/Components/BuyButton'),
        });

        const {
            articleNumber,
            quantityFieldId,
            href,
            cssClass,
            label,
            gtmTrackingData,
        } = button.dataset;
        renderReact(
            <Provider store={window.__pn.store}>
                <BuyButton
                    {...{
                        label,
                        articleNumber,
                        quantityFieldId,
                        href,
                        cssClass,
                        gtmTrackingData,
                    }}
                />
            </Provider>,
            button
        );
    };

    const buyButtons = document.querySelectorAll('buy-button');
    if (buyButtons.length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('../_PandoNexis/Components/BuyButton'), // import('../Components/BuyButton'),
        });
        Array.from(buyButtons).forEach(
            (button) => {
                initNewBuyButton(button, BuyButton);
            }
        );
    }

    // Modal login
    const modalLoginEl = document.getElementById('modalLogin');
    if (modalLoginEl) {
        const ModalLogin = DynamicComponent({
            loader: () => import('../_PandoNexis/Components/ModalLogin'),
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <ModalLogin />
            </Provider>,
            modalLoginEl
        );
    }
    // END Modal login
        
    // PRODUCT PAGE IMAGES
    const lightBoxImagesEl = document.getElementById('lightBoxImages');
    if (lightBoxImagesEl) {
        const { flags } = lightBoxImagesEl?.dataset || '';
        const LightboxImages = DynamicComponent({
            loader: () => import('../_Solution/Components/LightboxImages'),
        });
        import('../Reducers/LightboxImages.reducer').then(
            ({ lightboxImages }) => {
                window.__pn.store.injectReducer('lightboxImages', lightboxImages);
                const rootElement = lightBoxImagesEl;
                const images = Array.from(
                    rootElement.querySelectorAll('template')
                ).map((img) => ({
                    html: img.innerHTML,
                    src: img.dataset.src,
                    type: img.dataset.type,
                    videoSrc: img.dataset.videoSrc,
                    title: img.dataset.title,
                }));
                renderReact(
                    <Provider store={window.__pn.store}>
                        <LightboxImages images={images} flags={flags?.split('|') || []} />
                    </Provider>,
                    lightBoxImagesEl
                );
            }
        );
    }
    // END PRODUCT PAGE IMAGES

    // ICONS
    const iconEls = document.querySelectorAll('.pn-icon');
    if (iconEls) {
        const PnIcon = DynamicComponent({
            loader: () => import('../_PandoNexis/Components/PnIcon'),
        });
        iconEls.forEach((elem) => {
            const { iconName, title, width, height } = elem.dataset;
            ReactDOM.render(
                <Provider store={window.__pn.store}>
                    <PnIcon iconName={iconName} title={title} width={width} height={height} />
                </Provider>,
                elem
            );
        });
    }

    // ADDONS
    //PandoNexis: BEGIN  COMPONENT
    // PNGenericDataView
    const pnGenericDataViewGlobalDataInfo = document.getElementById("PNGenericDataViewGlobalDataInfo");
    if (pnGenericDataViewGlobalDataInfo) {
        const GlobalInfoDataContainer = DynamicComponent({
            loader: () => import('../_Addons/PNGenericDataView/Components/GlobalInfoData.container'),
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <GlobalInfoDataContainer />
            </Provider>,
            pnGenericDataViewGlobalDataInfo
        );
    }
    const pnGenericDataView = document.querySelectorAll(".generic-data-view__data");
    if (pnGenericDataView) {
        const PNGenericDataViewContainer = DynamicComponent({
            loader: () => import('../_Addons/PNGenericDataView/Components/PNGenericDataView.container'),
        });
        const calculateTableTop = () => {
            const gdvTable = document.querySelector(
                '.generic-data-view__table-wrapper:not(.in-modal)'
            );
            let footerHeight = 0;
            if (gdvTable) {
                const viewportOffset = gdvTable.getBoundingClientRect();
                const top = viewportOffset.top;

                const footerEl = document.querySelector('footer.footer');

                if (footerEl) {
                    const footerOffset = footerEl.getBoundingClientRect();
                    footerHeight = footerOffset.height;
                    if (footerHeight > 0) {
                        footerHeight += 32;
                    }
                }

                gdvTable.style.maxHeight =
                    'calc(100vh - ' + (top + footerHeight + 56) + 'px)';
            }
        };

        if (PNGenericDataViewContainer) {
            pnGenericDataView.forEach((elem, index) => {

                const { appendToQuerySelector, page, viewTypes, dataType } = elem.dataset;
                renderReact(
                    <Provider store={window.__pn.store}>
                        <PNGenericDataViewContainer pageSystemId={page} {...{ viewTypes, dataType }} />
                    </Provider>,
                    elem
                );
            });
        }

        const debounce = (func, wait) => {
            let timeout;
            return (...args) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => func(...args), wait);
            };
        };

        window.addEventListener('resize', debounce(calculateTableTop, 200));
    }
    // END PNGenericDataView

    // Mini Cart Extended (Off-canvas)

    const miniCartExtended = document.getElementById('PNMiniCartExtended');
    if (miniCartExtended) {
        const { isInCheckout, showInfo } = miniCartExtended.dataset || 'false';

        ReactDOM.render(
            <Provider store={window.__pn.store}>
                <MiniCartExtendedContainer
                    isInCheckout={isInCheckout === 'true'}
                    showInfo={showInfo}
                />
            </Provider>,
            miniCartExtended
        );
    }
    // END Mini Cart Extended (Off-canvas)

    // PandoNexis: END COMPONENT





}
